import React from 'react';
import { Link } from 'react-scroll';
import './Hero.css';

export default function Hero() {
	return (
		<section className='hero' id='hero'>
			<div className='hero__inner'>
				<div className='hero__badge'>DEVOPS · CLOUD · SECURITY</div>
				<h1 className='hero__heading'>
					Ship faster.
					<br />
					Break less.
					<br />
					<em>Scale with confidence.</em>
				</h1>
				<p className='hero__sub'>
					From pipeline chaos to production confidence — we modernize
					infrastructure, automate delivery, and build the security practices
					your team needs to move fast without breaking things.
				</p>
				<div className='hero__btns'>
					<Link to='contact' smooth={true} duration={500} offset={-60}>
						<button className='btn-primary'>Start a conversation</button>
					</Link>
					<Link to='services' smooth={true} duration={500} offset={-60}>
						<button className='btn-ghost'>See our services</button>
					</Link>
				</div>
			</div>
		</section>
	);
}
